import React, { useContext } from 'react';
import cleanLinkSrc from '../../../utils/xss/cleanLinkSrc';
import LazyContext from '../../../LazyLoadingImage/LazyContext';
const Img = (props)=>{
    const { file, deviation, imgStyles } = props;
    const enableLazyLoading = useContext(LazyContext);
    const isLazyLoaded = enableLazyLoading;
    return /*#__PURE__*/ React.createElement("img", {
        loading: isLazyLoaded ? 'lazy' : undefined,
        src: cleanLinkSrc(file.src),
        srcSet: file.srcSet,
        alt: deviation.title,
        style: imgStyles
    });
};
Img.displayName = 'Img';
export default Img;

//# sourceMappingURL=ImageBase.js.map